import { render } from "./RegistroSanitarioListado.vue?vue&type=template&id=42b9d4f8"
import script from "./RegistroSanitarioListado.vue?vue&type=script&lang=js"
export * from "./RegistroSanitarioListado.vue?vue&type=script&lang=js"

import "./RegistroSanitarioListado.vue?vue&type=style&index=0&id=42b9d4f8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__